import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { PopulateSegmentValuesDrawerComponent } from './populate-segment-values-drawer.component';

import { Group, GroupCustomSegmentTypes } from '@libs/src/models/group.model';
import { ColumnValue } from '@main-client/src/app/invite-csv/invite-csv-view/invite-csv-view.interface';

@Injectable()
export class PopulateSegmentValuesDrawerService {
  constructor(private readonly drawer: NzDrawerService) {}

  openDrawer({
    values,
    isPrivateSegment,
    group,
    customSegment,
  }: {
    customSegment: GroupCustomSegmentTypes;
    group: Group;
    isPrivateSegment: boolean;
    values: ColumnValue[];
  }) {
    return this.drawer.create({
      nzBodyStyle: { padding: 0 },
      nzClosable: true,
      nzContent: PopulateSegmentValuesDrawerComponent,
      nzData: { customSegment, group, isPrivateSegment, values },
      nzMaskClosable: false,
      nzTitle: $localize`:@@segmentValuesAutoPopulationDrawer.bulkAddAndMapOptions: Bulk add and map options`,
      nzWidth: '580px',
    });
  }
}
